import { AxiosResponse } from "axios";
import { useAppContext } from "../app/AppContextProvider";

export const useApiResponseErrorValidator = () => {
    const { logout } = useAppContext()
    return {
        validate: (response: AxiosResponse<any>) => validate(response, logout)
    }
}


const validate = (response: AxiosResponse<any>, logout: () => void) => {
    if (response?.status === 401)
        logout()
}